import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { marker } from '@jsverse/transloco-keys-manager/marker';
import { ToastController } from '@ionic/angular';
import { finalize } from 'rxjs';
import { PanelHostService } from '../../../../services/panel-host.service';
import { TripInfoService } from '../../../../services/trip-info.service';
import { TripService } from '../../../../services/trip.service';
import { ContentContainerComponent } from '../../../ui/content-container/content-container.component';
import { PanelBodyComponent } from '../../../ui/panel-body/panel-body.component';

@Component({
  selector: 'app-delete-flight-panel',
  imports: [TranslocoDirective, ContentContainerComponent, PanelBodyComponent],
  templateUrl: './delete-flight-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteFlightPanelComponent {
  private readonly panelHost = inject(PanelHostService);
  private readonly tripInfoService = inject(TripInfoService);
  private readonly tripService = inject(TripService);
  private readonly transloco = inject(TranslocoService);
  private readonly toastController = inject(ToastController);

  submitting = signal(false);
  flight = computed(() => this.panelHost.deleteFlightContext());

  cancel(): void {
    this.panelHost.dismiss();
  }

  confirm(): void {
    const trip = this.tripService.currentTrip.value();
    const flight = this.flight();
    if (!trip || !flight || this.submitting()) {
      return;
    }

    this.submitting.set(true);
    this.tripInfoService
      .deleteFlight(trip.id, flight.id)
      .pipe(finalize(() => this.submitting.set(false)))
      .subscribe({
        next: async () => {
          const toast = await this.toastController.create({
            message: this.transloco.translate(marker('flights.panel.deleteSuccess')),
            duration: 4000,
            color: 'success',
          });
          await toast.present();
          this.panelHost.dismiss();
        },
        error: async () => {
          const toast = await this.toastController.create({
            message: this.transloco.translate(marker('flights.panel.deleteError')),
            duration: 4000,
            color: 'danger',
          });
          await toast.present();
        },
      });
  }
}
